import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';

import { signOut } from '../session.service';

export function useLogout() {
  const queryClient = useQueryClient();
  const [isPending, setIsPending] = useState(false);

  const logout = useCallback(async () => {
    setIsPending(true);
    try {
      await signOut();
      // Without this, the previous account's cached data would flash on the next sign-in.
      queryClient.clear();
    } finally {
      setIsPending(false);
    }
  }, [queryClient]);

  return { logout, isPending };
}
